<div class="modal-header" *ngIf="IsModal">
  <h5 class="modal-title" id="editUserLabel">Invia</h5>
  <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <label  class="control-label col-form-label">Oggetto :</label>
        <input [(ngModel)]="Send.subject" type="text" class="form-control">
      </div>
      <div class="col-12">
        <label  class="control-label col-form-label">Contenuto :</label>
        <textarea [(ngModel)]="Send.body" rows="20" class="form-control"></textarea>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="send()">Invia</button>
</div>
